import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { AppUpdateNotice } from './components/AppUpdateNotice.js';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <React.StrictMode>
    <AppUpdateNotice />
    <App />
  </React.StrictMode>,
);
